import { forwardRef } from 'react';
import PendingCard from '@/components/Dashboard/DashboardPendings/PendingsCard';
import PerformanceCardHeader from './PerformanceCardHeader';
import PerformanceCardSummary from './PerformanceCardSummary';
import PerformanceCardContent from './PerformanceCardContent';

const PerformanceCard = forwardRef(
  ({ id = '', loading = false, children, ...rest }, ref) => (
    <PendingCard ref={ref} id={id} loading={loading} {...rest}>
      {children}
    </PendingCard>
  )
);

PerformanceCard.Header = PerformanceCardHeader;
PerformanceCard.Summary = PerformanceCardSummary;
PerformanceCard.Content = PerformanceCardContent;

export default PerformanceCard;
